/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Dataset_SeasonInputs */

const en_reference_dataset_season = /** @type {(inputs: Reference_Dataset_SeasonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seasons`)
};

/**
* | output |
* | --- |
* | "Seasons" |
*
* @param {Reference_Dataset_SeasonInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_dataset_season = /** @type {((inputs?: Reference_Dataset_SeasonInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Dataset_SeasonInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_dataset_season(inputs)
});